import { Col, Divider, Flex, Row } from 'antd'
import { Logo } from './logo'
import { Menus } from './menus'
import { StyledFooter, StyledRightsReservedText } from './styled'
import { SocialMediaLinks } from 'src/components/socialMediaLinks'

export const Footer = () => (
  <StyledFooter>
    <Row gutter={32} style={{ width: '100%' }}>
      <Col flex="1" style={{ alignItems: 'center', display: 'flex', justifyContent: 'center' }}>
        <Logo />
      </Col>
      <Col
        flex="2"
        style={{
          alignItems: 'flex-end',
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          gap: 60,
        }}
      >
        <Flex align="center" justify="stretch" gap={20}>
          <Menus />
          <Divider type="vertical" style={{ borderColor: '#ffffff', height: '100%' }} />
          <SocialMediaLinks />
        </Flex>
        <StyledRightsReservedText>
          All rights reserved | {new Date().getFullYear()} © Connect Up
        </StyledRightsReservedText>
      </Col>
    </Row>
  </StyledFooter>
)
